import { SignUpModeEnum } from '@app/app.enum';
import * as models from '@app/models/index';
import { mapKeys } from 'lodash';
import * as queryString from 'query-string';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import SignUpFormComponent from '../sign-up-form.component';

class QuickSignUpStepperComponent extends Component<
	models.IQuickSignUpStepperComponentProps,
	models.IQuickSignUpStepperComponentState
> {
	constructor(props: models.IQuickSignUpStepperComponentProps) {
		super(props);
		this.state = {
			signUpKey: '',
		};
	}

	public componentDidMount() {
		if (this.props.location.search) {
			this.getQueryParams();
		}
	}

	public render() {
		return (
			<SignUpFormComponent
				signUpKey={this.state.signUpKey}
				mode={SignUpModeEnum.Quick}
				onSignUp={this.props.onSignUp}
				quickSignUpConfiguration={{
					disableForm: this.props.disableForm,
					disabledFormAction: this.props.disabledFormAction,
					prefillFormValues: this.props.signUpFormData,
				}}
			/>
		);
	}
	private getQueryParams() {
		// Making all the keys of query-string parsed object to lowercase so to ignore casing in matching query params
		const queryParams = mapKeys(queryString.parse(this.props.location.search), (value, key) => key.toLowerCase());
		this.setState({
			signUpKey: queryParams.signupkey?.toString(),
		});
	}
}

export default withRouter(QuickSignUpStepperComponent);



// WEBPACK FOOTER //
// ./src/components/account/signup/quick/quick-signup-stepper.component.tsx